import i18n from 'i18next';

export const REEL_QUANTITY = 3;
export const REEL_INIT_DISPLAY_BLOCK_QUANTITY = 3;
export const REEL_LENGTH = 30;
export const PRIZE_POSITION = 1;
export const SLOT_WINDOW_HEIGHT = 222;
export const SLOT_WIDTH = 640;
export const GAP_SIZE = 16;
export const BLOCK_QUANTITY = 30;
export const BLOCK_SIZE = 114;

export const slotsBackgroundImg = 'https://assets.fevercdn.com/promotion/img/Slots_BG_Desktop.png';
export const slotsMbBackgroundImg = 'https://assets.fevercdn.com/promotion/img/Slots_BG_Mobile.png';

export const systemIcons = [
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_1.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_2.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_3.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_4.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_5.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_6.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_7.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_8.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_9.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_10.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_11.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_12.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_13.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_14.svg',
    'https://assets.fevercdn.com/promotion/img/Slots_SystemIcon_15.svg'
];

export const DEFAULT_ITEMS = Array.from(Array(10), (_, i) => ({
    id: `default_${i}`,
    imgUrl: `https://via.placeholder.com/300x154.png?text=prize-${i}`
}));

export const defaultKeyVisualConfig = {
    customImgUrl: 'https://assets.fevercdn.com/promotion/img/Slots_Cover%402x.png'
};

export const defaultStartButtonConfig = {
    text: i18n.t('label.slots.start_button'),
    color: 'hsla(0, 0%, 100%, 1)',
    colorBg: 'hsla(44, 100%, 50%, 1)',
    isUseCustomImg: false,
    customImgUrl: ''
};

export const defaultHandleConfig = {
    colorGrip: '#D7181E',
    colorBar: '#FFBA00',
    colorBase: '#FFBA00',
    isHandleShow: true
};

export const defaultWindowConfig = {
    colorBorder1: '#FFBA00',
    colorBorder2: '#D40000',
    colorNeons: '#FFB666',
    colorReelBg: 'white',
    hueNeons: '31',
    isNeonAnimated: true,
    isUseCustomImg: false,
    customImgUrl: ''
};

export const calcNeonsColor = hue => `rgba(${hue},102,255,1)`;

export const defaultDecorationsConfig = [];

export const BORDER_PREVIEW = {
    KEYVISUAL: 'keyvisual',
    WINDOW: 'window',
    START_BUTTON: 'startButton'
};
